// Work time (admin only) — lives under Statistics as a sidebar sub-item. Three pages:
// Dashboard (progress), Calendar (month grid + day editor), Workforce (who's tracked + schedules).
import React, { useState } from 'react';
import WorkTimeDashboard from './WorkTimeDashboard';
import WorkCalendar from './WorkCalendar';
import WorkforceSettings from './WorkforceSettings';
import AbsencesPanel from './AbsencesPanel';
import VacationPanel from './VacationPanel';
import AnnualPanel from './AnnualPanel';

type Tab = 'dashboard' | 'calendar' | 'absences' | 'vacation' | 'annual' | 'workforce';
const TABS: [Tab, string][] = [
  ['dashboard', 'Dashboard'], ['calendar', 'Calendar'],
  ['absences', 'Absences'], ['vacation', 'Vacation'],
  ['annual', 'Year review'], ['workforce', 'Workforce'],
];

export default function WorkTimePage() {
  const role = localStorage.getItem('wms_role') || 'staff';
  const [tab, setTab] = useState<Tab>('dashboard');

  if (role !== 'admin') {
    return <div className="p-6 text-gray-400 text-sm">Work time is available to admins only.</div>;
  }

  return (
    <div className="p-6 max-w-6xl">
      <div className="mb-5">
        <h1 className="text-2xl font-bold text-white">Work time</h1>
        <p className="text-gray-500 text-sm mt-0.5">Attendance, hours, absences and schedules for tracked workers</p>
      </div>

      <div className="flex gap-1 border-b border-gray-800 mb-6">
        {TABS.map(([key, label]) => (
          <button key={key} onClick={() => setTab(key)}
            className={`px-4 py-2 text-sm font-medium rounded-t-lg transition-colors ${
              tab === key ? 'text-white border-b-2 border-blue-500' : 'text-gray-400 hover:text-white'
            }`}>
            {label}
          </button>
        ))}
      </div>

      {tab === 'dashboard' && <WorkTimeDashboard />}
      {tab === 'calendar'  && <WorkCalendar />}
      {tab === 'absences'  && <AbsencesPanel />}
      {tab === 'vacation'  && <VacationPanel />}
      {tab === 'annual'    && <AnnualPanel />}
      {tab === 'workforce' && <WorkforceSettings />}
    </div>
  );
}
